var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MenuHeader',{attrs:{"logo":_vm.logo}}),_c('MenuLeft'),_c('div',{staticClass:"layout-main",attrs:{"id":"main"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }